import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { backend_url } from '../config/url.config';

@Injectable({
    providedIn: 'root'
})
export class CovidDoctor {

    readonly URL_API_PUBLIC_LOCATION = backend_url + '/api/localities/publics/';
    readonly URL_API_PRIVATE_LOCATION = backend_url + '/api/localities/privates/';

    readonly URL_API_PUBLIC_STATES = backend_url + '/api/states/publicDoctors/';
    readonly URL_API_PRIVATE_STATES = backend_url + '/api/states/privateDoctors/';

    readonly URL_API_PUBLIC_MUNICIPALITY = backend_url + '/api/municipalities/publicDoctors/';
    readonly URL_API_PRIVATE_MUNICIPALITY = backend_url + '/api/municipalities/privateDoctors/';

    readonly URL_API_PRIVATE_METROPOLITAN = backend_url + '/api/metropolitanAreas/privateDoctors/';
    readonly URL_API_PUBLIC_METROPOLITAN = backend_url + '/api/metropolitanAreas/publicDoctors/';

    constructor(private http: HttpClient) { }

    getPublic(cve, level, wkt="") {
        switch (level) {
            case "Estado":
                return this.http.post(this.URL_API_PUBLIC_STATES, {
                    "token": "o:-t3zTt0q3n-:o",
                    "entidad_cvegeo": cve
                });
            case "Municipio":
            case "ZonaMunicipio":
                return this.http.post(this.URL_API_PUBLIC_MUNICIPALITY, {
                    "token": "o:-t3zTt0q3n-:o",
                    "municipio_cvegeo": cve
                });
            case "Localidad":
            case "ZonaLocalidad":
                return this.http.post(this.URL_API_PUBLIC_LOCATION, {
                    "token": "o:-t3zTt0q3n-:o",
                    "cve_loc": cve
                });
            case "Metropolitan":
                return this.http.post(this.URL_API_PUBLIC_METROPOLITAN, {
                    "token": "o:-t3zTt0q3n-:o",
                    "wkt": wkt
                });
            default:
                return this.http.post(this.URL_API_PUBLIC_STATES, {
                    "token": "o:-t3zTt0q3n-:o",
                    "entidad_cvegeo": cve
                });
        }
    }

    getPrivate(cve, level, wkt=""){
        switch (level) {
            case "Estado":
                return this.http.post(this.URL_API_PRIVATE_STATES, {
                    "token": "o:-t3zTt0q3n-:o",
                    "entidad_cvegeo": cve
                });
            case "Municipio":
            case "ZonaMunicipio":
                return this.http.post(this.URL_API_PRIVATE_MUNICIPALITY, {
                    "token": "o:-t3zTt0q3n-:o",
                    "municipio_cvegeo": cve
                });
            case "Localidad":
            case "ZonaLocalidad":                
                return this.http.post(this.URL_API_PRIVATE_LOCATION, {
                    "token": "o:-t3zTt0q3n-:o",
                    "cve_loc": cve
                });
            case "Metropolitan":
                return this.http.post(this.URL_API_PRIVATE_METROPOLITAN, {
                    "token": "o:-t3zTt0q3n-:o",
                    "wkt": wkt
                });
            default:
                return this.http.post(this.URL_API_PRIVATE_STATES, {
                    "token": "o:-t3zTt0q3n-:o",
                    "entidad_cvegeo": cve
                });
        }
    }
}
